import React, { useEffect } from "react"
import { Navigate } from "react-router-dom"

// Pages Component
// Profile
import UserProfile from "../pages/Authentication/user-profile"

//Pages User
import UserList from "../pages/CompanyManagement/UserList/index"

// Apparel
import ApparelList from "../pages/Apparel/List/index"
import ApparelPrinter from "../pages/Apparel/Printer/index"
import ApparelFinancial from "../pages/Apparel/Financial/index"

// Engraving
import EngravingList from "../pages/Engraving/List/index"
import DesignUpload from "../pages/Engraving/AddDesign"
import EngravingAdd from "pages/Engraving/AddEngraving/index"
import EngravingFinancial from "../pages/Engraving/Financial/index"
import EngravingPrinter from "../pages/Engraving/Printer/index"

// Print
import PrintStyleManagement from "pages/PrintStyleSizeColorManagement/Style"
import PrintStyleSizeManagement from "pages/PrintStyleSizeColorManagement/SizesForColors"
import PrintStyleColorManagement from "pages/PrintStyleSizeColorManagement/ColorsForStyles"
import PrintPriceManagement from "pages/Print/PrintPriceManagement"

import Company from "../pages/CompanyManagement/Company/index"
import MainCompany from "../pages/CompanyManagement/MainCompany/index"
import MainCompanyUserList from "../pages/CompanyManagement/MainCompanyUserList/index"
import PriceManagement from "../pages/Apparel/PriceManagement"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import Pages404 from "../pages/NotFound/pages-404"
import Pages403 from "../pages/NotFound/pages-403"
import Pages500 from "../pages/NotFound/pages-500"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import PackageList from "pages/Package/ListUpload"
import PackageListDownload from "pages/Package/ListDonwload"
import PackageFinancial from "pages/Package/Financial"
import PackageManagement from "pages/Package/Management"
import UVDTFList from "pages/UvDTF/List"
import DTFList from "pages/DTF/List"
import DTFManagement from "pages/DTF/Management"
import UVDTFManagement from "pages/UvDTF/Management"
import UVDTFFinancial from "pages/UvDTF/Financial"
import StyleColorManagement from "pages/StyleSizeColorManagement/ColorsForStyles"
import ApparelAdd from "pages/Apparel/AddApparel"
import StyleSizeManagement from "pages/StyleSizeColorManagement/SizesForColors"
import StyleManagement from "pages/StyleSizeColorManagement/Style"
import AddTemplateImage from "../pages/Engraving/TemplateImage/addTemplateImage"
import EngravingTemplateImage from "pages/Engraving/TemplateImage"
import EngravingPriceManagement from "pages/Engraving/PriceManagement"
import EngravingStockTracking from "pages/Engraving/StockTracking"
import PaymentManagement from "pages/PaymentManagement"
import EngravingWaitingList from "pages/Engraving/WaitingList"
import DTFFinancial from "pages/DTF/Financial"
import DTFPrinter from "pages/DTF/Printer"
import UVDTFPrinter from "pages/UvDTF/Printer"
import ApparelDesignUpload from "pages/Apparel/AddDesign"
import ApparelWaitingList from "pages/Apparel/WaitingList"
import MultipleUploadCsv from "pages/MultipleProcess/UploadCsv"
import MultipleOrderList from "pages/MultipleProcess/OrderList"
import MultipleEngravingDesignUpload from "pages/MultipleProcess/AddDesignEngraving"
import MultipleApparelDesignUpload from "pages/MultipleProcess/AddDesignApparel"
import MultiplePrintDesignUpload from "pages/MultipleProcess/AddDesignPrint"
import PrintList from "pages/Print/List"
import PrintPrinter from "pages/Print/Printer"
import PrintWaitingList from "pages/Print/WaitingList"
import MultipleWaitingList from "pages/MultipleProcess/WaitingList"
import MultipleShipment from "pages/MultipleProcess/Printer"
import PrintUvFlatList from "pages/Print/UvFlat/List"
import PrintUvFlatPrinter from "pages/Print/UvFlat/Printer"
import PrintEcoSolventList from "pages/Print/EcoSolvent/List"
import PrintEcoSolventPrinter from "pages/Print/EcoSolvent/Printer"
import PrintSubliminationList from "pages/Print/Sublimination/List"
import PrintSubliminationPrinter from "pages/Print/Sublimination/Printer"
import PrintCncList from "pages/Print/Cnc/List"
import PrintCncPrinter from "pages/Print/Cnc/Printer"
import MultipleFinancial from "pages/MultipleProcess/Financial"
import MultiplePaymentManagement from "pages/MultipleProcess/PaymentManagement"
import DtfPaymentManagement from "pages/DTF/Payment/index"
import PrintUvPrintList from "pages/Print/UvPrint/List"
import PrintUvPrintPrinter from "pages/Print/UvPrint/Printer"
import EngravingUvPrintList from "pages/Engraving/UvPrint/List"
import EngravingUvPrintPrinter from "pages/Engraving/UvPrint/Printer"
import UvPrintWaitingList from "pages/Print/UvPrint/WaitingList"
import UvFlatWaitingList from "pages/Print/UvFlat/WaitingList"
import SubliminationWaitingList from "pages/Print/Sublimination/WaitingList"
import EcoSolventWaitingList from "pages/Print/EcoSolvent/WaitingList"
import CncWaitingList from "pages/Print/Cnc/WaitingList"
import EngravingListOld from "pages/Engraving/List/oldEngravingList"
import MultipleUploadFromShipStationCsv from "pages/MultipleProcess/UploadCsv/indexShipStation"
import UvDtfPaymentManagement from "pages/UvDTF/Payment"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  //Utility
  {
    path: "/user-list",
    component: <UserList />,
  },
  {
    path: "/main-company-list",
    component: <MainCompany />,
  },
  {
    path: "/main-company-user-list",
    component: <MainCompanyUserList />,
  },
  {
    path: "/price-management",
    component: <PriceManagement />,
  },
  {
    path: "/add-engraving-image",
    component: <AddTemplateImage />,
  },

  {
    path: "/company-list",
    component: <Company />,
  },
  {
    path: "/multiple-order-list",
    component: <MultipleOrderList />,
  },
  {
    path: "/multiple-upload-csv",
    component: <MultipleUploadCsv />,
  },
  {
    path: "/multiple-upload-from-shipstation-csv",
    component: <MultipleUploadFromShipStationCsv />,
  },
  { path: "/multiple-waiting-for-desing", component: <MultipleWaitingList/> },
  { path: "/multiple-shipment", component: <MultipleShipment/> },
  { path: "/multiple-financial", component: <MultipleFinancial /> },
  {
    path: "/multiple-payment-management",
    component: <MultiplePaymentManagement />,
  },

  // Apparel
  // { path: "/apparel-add", component: <ApparelAdd /> },
  { path: "/apparel-list", component: <ApparelList /> },
  { path: "/apparel-financial", component: <ApparelFinancial /> },
  { path: "/apparel-financial", component: <ApparelFinancial /> },
  { path: "/apparel-printer", component: <ApparelPrinter /> },
  { path: "/apparel-design-upload", component: <ApparelDesignUpload /> },
  {
    path: "waiting-for-desing-apparel",
    component: <ApparelWaitingList />,
  },
  {
    path: "/style-management",
    component: <StyleManagement />,
  },
  {
    path: "/color-management",
    component: <StyleColorManagement />,
  },
  {
    path: "/size-management",
    component: <StyleSizeManagement />,
  },

   // Print
  //  { path: "/print-add", component: <PrintAdd /> },
  { path: "/engraving-multiple-design-upload", component: <MultipleEngravingDesignUpload /> },
  {path:"/apparel-multiple-design-upload",component:<MultipleApparelDesignUpload/>},
  { path: "/print-multiple-design-upload", component: <MultiplePrintDesignUpload /> },

  // { path: "/print-list", component: <PrintList /> },
  // { path: "/print-printer", component: <PrintPrinter /> },

  { path: "/print-uv-flat-list", component: <PrintUvFlatList /> },
  { path: "/print-uv-flat-printer", component: <PrintUvFlatPrinter /> },

  { path: "/print-eco-solvent-list", component: <PrintEcoSolventList /> },
  { path: "/print-eco-solvent-printer", component: <PrintEcoSolventPrinter /> },

  { path: "/print-sublimination-list", component: <PrintSubliminationList /> },
  { path: "/print-sublimination-printer", component: <PrintSubliminationPrinter /> },

  { path: "/print-cnc-list", component: <PrintCncList /> },
  { path: "/print-cnc-printer", component: <PrintCncPrinter /> },

  { path: "/print-uv-print-list", component: <PrintUvPrintList /> },
  { path: "/print-uv-print-printer", component: <PrintUvPrintPrinter /> },
  {
    path: "waiting-for-desing-print",
    component: <PrintWaitingList/>,
  },
  {
    path: "waiting-for-desing-uv-print",
    component: <UvPrintWaitingList/>,
  },
  {
    path: "waiting-for-desing-uv-flat",
    component: <UvFlatWaitingList/>,
  },
  {
    path: "waiting-for-desing-sublimination",
    component: <SubliminationWaitingList/>,
  },
  {
    path: "waiting-for-desing-eco-solvent",
    component: <EcoSolventWaitingList/>,
  },
  {
    path: "waiting-for-desing-cnc",
    component: <CncWaitingList/>,
  },
  {
    path: "/print-style-management",
    component: <PrintStyleManagement />,
  },
  {
    path: "/print-size-management",
    component: <PrintStyleSizeManagement />,
  },
  {
    path: "/print-color-management",
    component: <PrintStyleColorManagement />,
  },
  {
    path: "/print-price-management",
    component: <PrintPriceManagement />,
  },

  // EngravingList
  { path: "/engraving-list-old", component: <EngravingListOld/> },
  

  { path: "/engraving-list", component: <EngravingList /> },
  { path: "/waiting-for-desing", component: <EngravingWaitingList /> },
  { path: "/engraving-design-upload", component: <DesignUpload /> },
  // { path: "/engraving-add", component: <EngravingAdd /> },
  { path: "/engraving-financial", component: <EngravingFinancial /> },
  { path: "/engraving-printer", component: <EngravingPrinter /> },

  { path: "/engraving-uv-print-list", component: <EngravingUvPrintList /> },
  { path: "/engraving-uv-print-printer", component: <EngravingUvPrintPrinter /> },

  {
    path: "/engraving-image-management",
    component: <EngravingTemplateImage />,
  },
  {
    path: "/engraving-price-management",
    component: <EngravingPriceManagement />,
  },
  {
    path: "/payment-management/:categoryId",
    component: <PaymentManagement />,
  },
  {
    path: "/engraving-stock-tracking",
    component: <EngravingStockTracking />,
  },

  // Package
  { path: "/package-list", component: <PackageList /> },
  { path: "/package-list-download", component: <PackageListDownload /> },
  { path: "/package-financial", component: <PackageFinancial /> },
  { path: "/package-price-management", component: <PackageManagement /> },

  //DTF
  { path: "/dtf-list", component: <DTFList /> },
  { path: "/dtf-financial", component: <DTFFinancial /> },
  { path: "/dtf-management", component: <DTFManagement /> },
  { path: "/dtf-printer", component: <DTFPrinter /> },
  {path: "/dtf-payment-management", component: <DtfPaymentManagement/>},
  // UVDTF

  { path: "/uvdtf-list", component: <UVDTFList /> },
  { path: "/uvdtf-financial", component: <UVDTFFinancial /> },
  { path: "/uvdtf-management", component: <UVDTFManagement /> },
  { path: "/uvdtf-printer", component: <UVDTFPrinter /> },
  {path: "/uvdtf-payment-management", component: <UvDtfPaymentManagement/>},


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/register", component: <Register /> },
  { path: "/not-found-403", component: <Pages403 /> },
  { path: "/not-found-404", component: <Pages404 /> },
  { path: "/not-found-500", component: <Pages500 /> },
]

export { authProtectedRoutes, publicRoutes }
